import { render } from "./PedidosListado.vue?vue&type=template&id=960f2afe"
import script from "./PedidosListado.vue?vue&type=script&lang=js"
export * from "./PedidosListado.vue?vue&type=script&lang=js"

import "./PedidosListado.vue?vue&type=style&index=0&id=960f2afe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__